import { useState } from 'react'
import ChangelogModal from '~/pages/Home/Modals/ChangelogModal/ChangelogModal'

export const useChangelogModal = () => {
  const [isOpen, setIsOpen] = useState(false)

  const showChangelog = () => setIsOpen(true)
  const hideChangelog = () => setIsOpen(false)

  const ChangelogModalComponent = (
    <ChangelogModal isOpen={isOpen} onClose={hideChangelog} />
  )

  return {
    showChangelog,
    hideChangelog,
    ChangelogModal: ChangelogModalComponent,
  }
}
